
<div class="row">
  <div class="col-lg-6 col-md-6 col-sm-12">
    @if (trades.size <= 0) {
      <h4>Waiting for trade stream...</h4>
    }
  </div>
  <div class="col-lg-6 col-md-6 col-sm-12 duration-header">
    <h4>Currencies traded in past {{duration}}:</h4>
  </div>
</div>
<div class="row">
  <div class="trade-stream col-lg-6 col-md-6 col-sm-12">
    <div id="trade-stream-divider"></div>
    @for (item of trades; track item) {
      <div class="trade-item highlight {{item.isEven ? '' : 'odd'}}">
        {{item.actionName }}
        <a class="link inline-link" href="{{item.linkHref}}" target="exchTab">{{item.linkText}}</a>
        {{item.note}}
      </div>
    }
  </div>
  <div class="assets-stats-panel col-lg-6 col-md-6 col-sm-12">
    <table id="assetStatisticsTable" matSort (matSortChange)="sortStatistics($event)">
      <tr>
        <th mat-sort-header="asset" colspan="2">Currency</th>
        <th mat-sort-header="trades">Trades</th>
        <th mat-sort-header="volume">Volume</th>
      </tr>

      @for (stat of sortedStatistics; track stat) {
        <tr>
          <td><img class="asset-icon" src="{{stat.assetIcon}}" title="{{stat.assetCode}}"/></td>
          <td>
            <a class="link inline-link blacklist-link" (click)="addAssetToBlacklist(stat)">&#9762;</a>
            {{stat.assetTitle}}
          </td>
          <td>{{stat.numTrades}}</td>
          <td>
            {{Utils.formatAmount(stat.volume)}} {{stat.assetCode}}
            @if (stat.volumeInNative > 0) {
              <span>(~{{Utils.formatAmount(stat.volumeInNative)}} XLM)</span>
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>
<div class="row" class="filter-panel">
  <form (submit)="addFullnameFilter(filterTextForm)" #filterTextForm="ngForm">
    <input type="text" [(ngModel)]="inputFilterText" #newFilterText="ngModel" name="newFilterText" placeholder="-ste11ar.org"/>
    <button type="submit" class="nebularBtn add-filter-button">Add filter</button>
  </form>
  Full-name filters:
  @for (filterText of fullnameFilters; track filterText) {
    <div class="chip gray-border">
      {{ filterText }}
      <a class="link inline-link remove-icon" (click)="removeFullnameFilter(filterText)">&#9746;</a>
    </div>
  }
  @if (directAssetBlacklist.size > 0) {
    <div id="currencyBlackList">
      Currency blacklist:
      @for (blackAsset of directAssetBlacklist.values(); track blackAsset) {
        <div class="chip orange-border">
          {{ blackAsset.assetTitle ?? blackAsset.assetCode }}
          <a class="link inline-link remove-icon" (click)="removeAssetFromBlacklist(blackAsset)">&#9746;</a>
        </div>
      }
    </div>
  }
</div>